module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": "",
      "three-line": "",
      "subheader": ""
    }
  }, [(_vm.title) ? _c('v-subheader', [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.fetch
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('span', {
    staticClass: "ml-3 overline"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "placeholder": "search",
      "append-icon": "search"
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.filteredTemplates), function(template) {
    return [_c('v-list-tile', {
      key: template.id,
      on: {
        "click": function($event) {
          return _vm.$emit("selected", template)
        }
      }
    }, [(_vm.showNew) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit("selected", template)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(template.ui_action_name || template.name) + "\n          "), (template.owner != "0") ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "primary",
        "x-small": "",
        "outline": "",
        "outlined": ""
      }
    }, [_vm._v("custom")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(template.description))]), _vm._v(" "), _c('v-list-tile-sub-title', [(template.is_active) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "color": "success",
        "dark": ""
      }
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "small": ""
      }
    }, [_vm._v("check")]), _vm._v("\n            Active\n          ")], 1) : _vm._e(), _vm._v(" "), (template.shared) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      attrs: {
        "outline": ""
      }
    }, [_vm._v("\n            Shared\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((template.categories), function(category) {
      return _c('v-chip', {
        key: category.id,
        staticClass: "v-chip--x-small"
      }, [_vm._v("\n            " + _vm._s(category.name) + "\n          ")])
    }), _vm._v(" "), (template.spaces && template.spaces.length > 0) ? _c('space-faces', {
      attrs: {
        "space-ids": template.spaces
      }
    }) : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (template.id))
    })]
  }), _vm._v(" "), (_vm.showNew) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("new", null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n    Create a new template\n  ")], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ed55876","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/CommunicationTemplateList.vue
// module id = 1325
// module chunks = 9